import { useLoadingStore } from "@/core/services/loading/loading.store";
import type { Router } from "vue-router";

function isPublicRoute(path: string) {
  return path.startsWith("/login");
}

export function installRouteLoadingSpinner(router: Router) {
  const loading = useLoadingStore();
  let timer: number | null = null;
  let didShow = false;

  router.beforeEach((to, _from, next) => {
    // Cancel any pending delayed show from previous nav
    if (timer !== null) {
      window.clearTimeout(timer);
      timer = null;
    }

    didShow = false;

    // Don't show page spinner on login/public routes
    if (isPublicRoute(to.path)) {
      loading.reset();
      next();
      return;
    }

    timer = window.setTimeout(() => {
      loading.show("Loading page…", true);
      didShow = true;
      timer = null;
    }, 120);

    next();
  });

  const stop = (to?: any) => {
    if (timer !== null) {
      window.clearTimeout(timer);
      timer = null;
    }

    // If we showed the "page" spinner, clear it hard.
    // reset() is safest because axios might also be using count.
    if (didShow && (!to || !isPublicRoute(to.path))) {
      loading.reset();
    } else {
      // otherwise just make sure it's not active
      loading.hide();
    }

    didShow = false;
  };

  router.afterEach((to) => stop(to));
  router.onError(() => stop());
}
